export const getCurrentCategoryFilterSelect = (cardToDrag, currentWorks) => {
  if (cardToDrag && cardToDrag?.category && cardToDrag?.category?.category_name) {
    return [cardToDrag.category.category_name];
  }
  if (currentWorks.length > 0) {
    return currentWorks.map(item => item.category_name)
  }

  return null;
}